import '../../App.css'
import { useState, useEffect } from 'react';
import { Table, Select, Pagination } from 'antd';
import { Link } from "react-router-dom";
import axios from 'axios';
import Appconfig from '../../config/config'
import moment from 'moment';
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import AccountSidebar from '../../components/AccountSidebar'; 

function ProfitLoss() {
    const userInfo = useSelector((state) => state?.userInfo?.userdata);

    const [filteredData, setFilteredData] = useState([]);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [formData, setFormData] = useState({
        "user_id": userInfo && userInfo?._id,
        "from_date": moment().subtract(1, 'days').format('YYYY-MM-DD'),
        "to_date": moment().format('YYYY-MM-DD'),
    });

    // *************** Calendar Logic ****************
    const [showFromCalendar, setShowFromCalendar] = useState(false);
    const [showToCalendar, setShowToCalendar] = useState(false);

    const handleFromDate = (newDate) => {
        if (newDate) {
            setFormData({ ...formData, from_date: newDate });
            setShowFromCalendar(false);
        }
    };

    const handleToDate = (newDate) => {
        if (newDate) {
            setFormData({ ...formData, to_date: newDate });
            setShowToCalendar(false);
        }
    };

    const formattedFromDate = formData.from_date ? format(new Date(formData.from_date), 'yyyy-MM-dd') : '';
    const formattedToDate = formData.to_date ? format(new Date(formData.to_date), 'yyyy-MM-dd') : '';

    const handleJustForToday = () => {
        const today = moment().format('YYYY-MM-DD');
        setFormData({ ...formData, from_date: today, to_date: today });
    };

    const handleFromYesterday = () => {
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const today = moment().format('YYYY-MM-DD');
        setFormData({ ...formData, from_date: yesterday, to_date: today });
    };

    // *************** Table Configuration ****************
    let locale = { emptyText: 'No data!' };
    const columns = [
        {
            title: 'Sport Name',
            dataIndex: 'name',
            sorter: true,
            width: 150, 
            render: (_, record) => {
                const eventMap = {
                    4: 'Cricket', 2: 'Tennis', 1: 'Soccer', 7: 'Horse Racing',
                    777: 'WCO Casino', 4339: 'Greyhound Racing', 27979456: 'Kabaddi',
                    7522: 'Basketball', 2378961: 'Politics', 66101: 'Virtual', 66104: 'Lottery'
                };
                const name = eventMap[record.event_type] || 'Casino';
                return (
                    <Link className='font-extrabold text-[#2789ce] text-[0.813rem]' to={`/profit-loss-event/${record.event_type}/${formData.from_date}/${formData.to_date}`}>
                        {name}
                    </Link>
                );
            },
        },
        {
            title: 'Profit/Loss',
            dataIndex: 'totalPL',
            sorter: true,
            width: 120,
            render: (text) => (
                <span className={`font-extrabold text-[0.813rem] ${text < 0 ? 'text-[#ff0000]' : 'text-[#008000]'}`}>
                    {Number(text).toFixed(2)}
                </span>
            )
        },
        {
            title: 'Commission',
            dataIndex: 'commissionAmount',
            sorter: true,
            width: 120,
            render: (text) => (
                <span className='font-extrabold text-[green] text-[0.813rem]'>{Number(text).toFixed(2)}</span>
            )
        },
        {
            title: 'Total P&L',
            width: 120,
            render: (_, record) => {
                const total = record.totalPL + record.commissionAmount;
                return (
                    <span className={`font-extrabold text-[0.813rem] ${record.totalPL < 0 ? 'text-[#ff0000]' : 'text-[#008000]'}`}>
                        {total.toFixed(2)}
                    </span>
                );
            }
        },
    ];

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredData?.slice(startIndex, endIndex);

    useEffect(() => {
        filterProfitLoss();
    }, []);

    const filterProfitLoss = async () => {
        var data = JSON.stringify(formData);
        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/auraProfitLossByEventType`,
            headers: { 'Content-Type': 'application/json' },
            data: data
        };

        axios(config)
            .then(function (response) {
                try {
                    setFilteredData(response.data.resultData);
                } catch (e) { }
            })
            .catch(function (error) { console.log(error); });
    }

    const tabs = ['Exchange', 'FancyBet', 'Casino', 'Sportsbook', 'BookMaker', 'BPoker', 'SABA', 'MiniGame', 'Royal'];

    return (
        <div className="bg-[#eeeeee] min-h-screen font-sans">
            {/* FIX: Added pt-[70px] for mobile to clear fixed Header (approx 56px) 
               FIX: Added pb-[80px] for mobile to clear fixed Footer 
               lg:pt-2 and lg:pb-0 reset this for desktop
            */}
            <div className="max-w-[1300px] mx-auto flex flex-col lg:flex-row gap-4 items-start pt-[70px] pb-[80px] px-0 lg:pt-0 lg:pb-0">
                
                {/* 1. Sidebar */}
                <div className="w-full lg:w-auto">
                    <AccountSidebar />
                </div>
                {/* 2. Main Content (Right Side) */}
                <div className="flex-1 w-full">
                    <h2 className="text-sm font-bold mb-1 mt-1 text-gray-800">My Bets</h2>
                <div className="flex-1 w-full bg-white shadow-sm text-sm overflow-hidden">
                    
                    {/* --- Header Section --- */}
                    <div className="px-4 py-3 border-b border-gray-200">
                        <h2 className="text-lg font-bold text-gray-800">
                            Profit & Loss - Main wallet
                        </h2>
                        <div className="text-xs text-gray-500 mt-1 flex flex-wrap gap-2">
                            <span className="font-semibold text-black">{userInfo?.username || 'userteam'}</span>
                            <span className='hidden md:inline'>|</span>
                            <span>{moment().format('YYYY-MM-DD HH:mm')}</span>
                        </div>
                    </div>

                    {/* --- Tabs Section --- */}
                    <div className="px-2 mt-4 border-b border-[#243a48] overflow-x-auto">
                        <div className="flex flex-nowrap md:flex-wrap gap-1 min-w-max">
                            {tabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`px-4 py-2 text-xs font-bold rounded-t-md border-t border-l border-r border-gray-300 whitespace-nowrap
                                        ${index === 0 
                                            ? 'bg-[#243a48] text-white border-[#243a48]' 
                                            : 'bg-[#f0f2f5] text-gray-700 hover:bg-gray-100'
                                        }`}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* --- Filters Section (Gray Bar) --- */}
                    <div className="bg-[#e0e6e6] p-3 border border-gray-300">
                        <div className="flex flex-col md:flex-row md:items-center gap-3">
                            
                            {/* Date Pickers */}
                            <div className="flex items-center gap-2 w-full md:w-auto">
                                <span className="font-bold text-gray-700 whitespace-nowrap">Period</span>
                                
                                <div className="relative flex-1 md:flex-none">
                                    <input
                                        type="text"
                                        readOnly
                                        value={formattedFromDate}
                                        onClick={() => { setShowFromCalendar(!showFromCalendar); setShowToCalendar(false); }}
                                        className="w-full md:w-[110px] px-2 py-1 border border-gray-400 rounded-sm text-center cursor-pointer focus:outline-none"
                                    />
                                    {showFromCalendar && (
                                        <div className="absolute top-full left-0 z-50 mt-1">
                                            <Calendar onChange={handleFromDate} value={formData.from_date || new Date()} />
                                        </div>
                                    )}
                                </div>

                                <span className="font-bold text-gray-700">to</span>

                                <div className="relative flex-1 md:flex-none">
                                    <input
                                        type="text"
                                        readOnly
                                        value={formattedToDate}
                                        onClick={() => { setShowToCalendar(!showToCalendar); setShowFromCalendar(false); }}
                                        className="w-full md:w-[110px] px-2 py-1 border border-gray-400 rounded-sm text-center cursor-pointer focus:outline-none"
                                    />
                                    {showToCalendar && (
                                        <div className="absolute top-full right-0 md:left-0 z-50 mt-1">
                                            <Calendar onChange={handleToDate} value={formData.to_date || new Date()} />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Quick Buttons */}
                            <div className="flex flex-wrap items-center gap-2 mt-2 md:mt-0">
                                <button 
                                    onClick={handleJustForToday}
                                    className="flex-1 md:flex-none px-3 py-1 bg-white border border-gray-400 rounded-sm text-xs font-bold hover:bg-gray-50 transition whitespace-nowrap"
                                >
                                    Just For Today
                                </button>
                                <button 
                                    onClick={handleFromYesterday}
                                    className="flex-1 md:flex-none px-3 py-1 bg-white border border-gray-400 rounded-sm text-xs font-bold hover:bg-gray-50 transition whitespace-nowrap"
                                >
                                    From Yesterday
                                </button>
                                
                                <button 
                                    onClick={filterProfitLoss}
                                    className="w-full md:w-auto px-4 py-1 md:ml-2 bg-gradient-to-b from-[#474747] to-[#070707] text-white border border-gray-600 rounded-sm text-xs font-bold hover:opacity-90 mt-2 md:mt-0"
                                >
                                    Get P & L
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* --- Info Text --- */}
                    <div className="p-3 text-xs text-gray-600">
                        <p>Betting Profit & Loss enables you to review the bets you have placed.</p>
                        <p>Specify the time period during which your bets were placed, the type of markets on which the bets were placed, and the sport.</p>
                        <p>Betting Profit & Loss is available online for the past 62 days.</p>
                        <p>User can search up to 14 days records per query only.</p>
                    </div>

                    {/* --- Table Section --- */}
                    <div className="p-4">
                        <Table
                            title={() => (
                                <div className='flex items-center text-sm'>
                                    Show
                                    <Select defaultValue={10} onChange={handlePageSizeChange} className='mx-2 w-[70px]' size="small">
                                        <Select.Option value={10}>10</Select.Option>
                                        <Select.Option value={25}>25</Select.Option>
                                        <Select.Option value={50}>50</Select.Option>
                                        <Select.Option value={100}>100</Select.Option>
                                    </Select>
                                    entries
                                </div>
                            )}
                            locale={locale}
                            columns={columns}
                            className='border border-gray-200'
                            bordered
                            dataSource={paginatedData}
                            pagination={false}
                            size="small"
                            scroll={{ x: 'max-content' }} 
                        />

                        {/* Custom Pagination Controls */}
                        <div className='flex flex-col md:flex-row justify-between items-center mt-4 text-xs text-gray-700 gap-3'>
                            <div className="text-center md:text-left">
                                Showing {startIndex + 1} to {Math.min(endIndex, filteredData?.length || 0)} of {filteredData?.length} entries
                            </div>
                            <div className='flex items-center'>
                                <button 
                                    className='px-3 py-1 border rounded mr-2 hover:bg-gray-100 disabled:opacity-50' 
                                    onClick={handleFirst}
                                    disabled={current === 1}
                                >First</button>
                                
                                <Pagination
                                    current={current}
                                    pageSize={pageSize}
                                    total={filteredData?.length}
                                    onChange={(page) => setCurrent(page)}
                                    showSizeChanger={false}
                                    itemRender={(page, type, originalElement) => {
                                        if (type === 'prev') return <button className='px-2'>Previous</button>;
                                        if (type === 'next') return <button className='px-2'>Next</button>;
                                        if (type === 'page') return null; 
                                        return originalElement;
                                    }}
                                />

                                <button 
                                    className='px-3 py-1 border rounded ml-2 hover:bg-gray-100 disabled:opacity-50' 
                                    onClick={handleLast}
                                    disabled={current >= Math.ceil(filteredData?.length / pageSize)}
                                >Last</button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}

export default ProfitLoss;